<template>
  <div class="smart-select__wrapper flex align-start flex-col mx-1">
    <VAutocomplete
      v-if="autocomplete"
      :key="`a-${keyProp}`"
      class="smart-select"
      :class="{
        'select--error': error !== null,
        'smart-input--focus': isFocus
      }"
      v-bind="$attrs"
      :items="items"
      :label="label"
      :item-text="itemText"
      :item-value="itemValue"
      :value="value"
      :name="name"
      v-on="listeners"
      :noDataText="noDataText"
    />
    <VSelect
      v-else
      class="smart-select"
      :class="{
        'select--error': error !== null
      }"
      v-bind="$attrs"
      :items="items"
      :label="label"
      :item-text="itemText"
      :item-value="itemValue"
      :value="value"
      :name="name"
      v-on.prevent="listeners"
      :noDataText="noDataText"
      :key="`s-${keyProp}`"
    />
    <div class="select-error" v-if="error !== null">{{ error }}</div>
  </div>
</template>

<script>
// @flow
export default {
  name: 'SmartSelect',
  props: {
    value: {}, // eslint-disable-line
    itemValue: {
      type: String,
      required: true
    },
    itemText: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: null
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    noDataText: {
      type: String,
      default: 'No data'
    },
    keyProp: {
      type: String,
      default: new Date().toTimeString()
    }
  },
  data() {
    return {
      isFocus: false,
    };
  },
  methods: {
    onFocus() {
      this.isFocus = true;
    },
    onBlur() {
      this.isFocus = false;
    }
  },
  computed: {
    listeners() {
      return {
        change: (event: InputEvent) => this.$emit('change', event),
        input: (event: InputEvent) => this.$emit('input', event),
        focus: this.onFocus,
        blur: this.onBlur
      };
    }
  }
};
</script>
<style lang="scss">
.smart-select__wrapper {
  margin-bottom: 0.7rem;
  .smart-select {
    width: 100%;
    margin-left: 0px;
    margin-bottom: $spacing-margin-xxxsmall !important;
  }
  .select--error {
    label {
      color: $color-ui-danger !important;
    }
    .v-select__slot {
      border-color: $color-ui-danger !important;
    }
  }
  .select-error {
    font-family: $font-family-01;
    color: $color-ui-gray;
    align-self: flex-end;
    font-size: $font-size-paragraph;
    color: $color-ui-danger !important;
  }
}
</style>
